// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_V_D","cls2":"BulkFollowSuggestion-cls2_sLD BulkFollowSuggestion-cls1_V_D"};